// extracted by mini-css-extract-plugin
module.exports = {"group":"RecipeIngredientGroup_group__B3TTL"};